(function ($) {

    let $sectionPanelCollapse = $('.section-bewerbungsprozess-accordion .panel-collapse');

    $sectionPanelCollapse.on('show.bs.collapse', function () {
        $(this).parent().addClass('opened');
    });

    $sectionPanelCollapse.on('hide.bs.collapse', function () {
        $(this).parent().removeClass('opened');
    });

})(jQuery);